import { FC } from 'react';
import { IonSplitPane } from '@ionic/react';
import { AllieTabs } from '../../../components/Tabs/Tabs';
import { AllieMainLayoutProps } from './MainLayout';

const AllieMainLayoutMobile: FC<AllieMainLayoutProps> = ({
  tabs,
  tabSelected,
  menu: Menu,
  page: Page,
}) => {
  return (
    <>
      {Menu && <Menu />}
      <div style={{ height: '100%', width: '100%', position: 'relative' }}>
        <Page />
      </div>
    </>
  );
};

export default AllieMainLayoutMobile;
